import React, { FC } from 'react';

import { getLevelIcon, Warning } from '@da-g3-acl/shared/common';

import styles from './index.module.scss';

interface StatusBarItemWarningsProps {
	warnings?: Warning[];
}

export const StatusBarItemWarnings: FC<StatusBarItemWarningsProps> = ({ warnings }) => {
	if (!warnings) return null;
	const maxLevel = warnings.map((w) => w.level).sort((a, b) => b - a)[0];
	return (
		<div className={styles.item} data-statusbar-item-type="warning">
			<span className={styles.warningIcon}>{getLevelIcon(maxLevel)}</span>
			<div className={styles.warningTooltipContainer}>
				<div className={styles.warningTooltipContent}>
					{warnings.map((w, idx) => (
						<div key={`warning-text=${idx}`} className={styles.warningTooltipItem}>
							<div className={styles.warningTooltipItemHeader}>
								<span className={styles.warningTooltipItemIcon}>{getLevelIcon(w.level)}</span>
								<span className={styles.warningTooltipItemTitle}>{w.title}</span>
							</div>
							{w.message &&
								(Array.isArray(w.message) ? w.message : [w.message]).map((m, idx) => (
									<div className={styles.warningTooltipItemText} key={`message-${idx}`}>
										{m}
									</div>
								))}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
